"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _image = require("@site/pattern-library-core/image");
const Brick = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Brick",
  class: "pl-bpaos4e"
});
const BrickInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BrickInner",
  class: "pl-b7pq3k4"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pl-i15v00uq"
});
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "pl-hwqjnrr"
});

/**
 * Waterfall Section Item component.
 *
 * @param {Object} props React props
 * @param {object} props.image Image Url and Alt text
 * @param {String} props.textAlign Support TextAlign for Each element
 * @param {String} props.headlineSize Support headlineSize for Each element
 * @param {String} props.description Support description for Each element
 * @param {String} props.headlineTag Support headlineTag for Each element
 * @param {String} props.ctaFlexDirection Support ctaFlexDirection for Each element
 * @param {String} props.headlineLineLength Support headlineLineLength for Each element
 * @param {String} props.heading Support heading for Each element
 * @param {Object} props.ctas Cta Props
 * @param {String} props.actionsLayout Support actionsLayout for each cta
 * @returns {React.ReactElement} Waterfall Item component
 * @public
 */

function WaterfallItem({
  image = {},
  ...headlineProps
}) {
  const {
    url,
    altText,
    height,
    width
  } = image;
  return /*#__PURE__*/_react.default.createElement(Brick, {
    "data-cy": "waterfall-item-section"
  }, /*#__PURE__*/_react.default.createElement(BrickInner, null, /*#__PURE__*/_react.default.createElement(Image, {
    "data-cy": "waterfall-item-image",
    url: url,
    altText: altText,
    height: height,
    width: width
  })), /*#__PURE__*/_react.default.createElement(HeadlineContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, headlineProps, {
    textAlign: "start"
  }))));
}
var _default = exports.default = WaterfallItem;
WaterfallItem.propTypes = {
  image: _propTypes.default.shape(_image.imgPropShape),
  ..._index.default.propTypes
};